export const actionType = {
    INIT_FORM: 'INIT_FORM',
    INIT_FORM_RETRY: 'INIT_FORM_RETRY',
    INIT_FORM_COMPLETED: 'INIT_FORM_COMPLETED',
    INIT_FORM_TIMEOUT: 'INIT_FORM_TIMEOUT',
    INIT_FORM_ERROR: 'INIT_FORM_ERROR'
} as const;
